//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useRef } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid, useTheme, useMediaQuery } from '@material-ui/core';
// import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// import SimpleBar from 'simplebar-react';
import CloseIcon from '@material-ui/icons/Close';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { logPageView } from '../../system/firebase';
import { PAGE_TITLE_RESOURCE_CENTER } from '../../common/constants';
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getCopyrightText } from '../../common/textHelper';
import { AFITD_DOMAIN, PATH_RESOURCE_CENTER } from '../../system/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import bannerImg from '../../images/ResourceCenter/Article 2 Main Image.jpg';
import bannerLogo from '../../images/ResourceCenter/article1Logo/afitd_primary_logo-01.svg';
import homeLogo from '../../images/ResourceCenter/article2Logo/home.png';
import questionLogo from '../../images/ResourceCenter/article2Logo/question.png';
import interviewLogo from '../../images/ResourceCenter/article2Logo/virtual.png';
import { useHistory } from 'react-router-dom';

// import cardImg1 from '../../images/FAQ/Rectangle 202.png';
// import cardImg2 from '../../images/FAQ/Rectangle 2021.png';
// import cardImg3 from '../../images/FAQ/Rectangle 2022.png';
// import shareImg1 from '../../images/FAQ/Vector1.png';
// import shareImg2 from '../../images/FAQ/Vector2 (1).png';
// import shareImg3 from '../../images/FAQ/Vector3 (1).png';
// import shareImg4 from '../../images/FAQ/Ic_copy link.png';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../../common/elemental/AfitdPageHead';
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    topText: { fontWeight: 700, fontSize: '16px', lineHeight: '19px', color: '#111E14', textAlign: 'center' },
    heading: {
        color: '#21898A',
        fontWeight: 700,
        fontSize: '42px',
        lineHeight: '52px',
        textAlign: 'center',
        maxWidth: '700px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px' },
    },
    bannerImg: { textAlign: 'center', marginTop: '45px', marginBottom: '40px' },
    paragraph: {
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: '36px',
        maxWidth: '730px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: '18px', lineHeight: '32px' },
    },
    questionTitle: {
        fontSize: '22px',
        fontWeight: 'bold',
        lineHeight: '36px',
        maxWidth: '730px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: '18px', lineHeight: '32px' },
    },
    secondaryHeader: {
        color: '#21898A',
        fontSize: '26px',
        fontWeight: '700',
        lineHeight: '30px',
        marginTop: '70px',
        maxWidth: '730px',
        // margin: 'auto',
        marginBottom: '24px',
        [theme.breakpoints.down('sm')]: { fontSize: 22, lineHeight: '25px' },
    },
    social: { maxWidth: '730px', margin: 'auto', marginTop: '50px', display: 'flex', alignItems: 'center', marginBottom: '30px' },
    iconContainer: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: 'rgba(252, 130, 31, 0.13)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    socialText: { fontSize: '16px', fontWeight: 700, lineHeight: '19px', paddingLeft: '16px' },
    hr: { backgroundColor: '#F0F2F6', margin: 'auto', marginTop: 50, maxWidth: '840px' },
    navigations: { display: 'flex', justifyContent: 'space-between', maxWidth: '1100px', margin: 'auto', marginTop: '20px' },
    navigationIconContainer: {
        display: 'flex',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: '1px solid #D5D7DD',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': { cursor: 'pointer' },
    },
    navigationText: { padding: '0 16px', fontSize: '20', width: '500', fontWeight: 'bold' },
    navigationButtonContainer: { display: 'flex', alignItems: 'center' },
    card: { width: '352px', borderRadius: '8px', border: '1px solid #D5D7DD', '&:hover': { cursor: 'pointer' } },
    cardContainer: { marginTop: '60px', marginBottom: 60 },
    cardContent: { marginBottom: '27px', marginLeft: '24px', marginRight: '20px', borderBottom: '20px solid #fafafc' },
    cardHeading: { fontSize: '26px', fontWeight: 'bold', lineHeight: '34px' },
    cardParagraph: { fontSize: '15px', fontWeight: 400, lineHeight: '24px' },
    cardSocial: { display: 'flex', alignItems: 'center', marginTop: '20px' },
    cardSocialText: { marginLeft: '9px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    cardSection: { display: 'flex', alignItems: 'flex-start', justifyContent: 'center' },
    dateTime: { marginBottom: 0, marginTop: '24px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    shareImageContainer: { textAlign: 'center', marginBottom: '16px', position: 'relative', '&:hover': { cursor: 'pointer' }, [theme.breakpoints.down('sm')]: { marginRight: 10 } },
    shareContainer: { display: 'flex', flexDirection: 'column', marginLeft: '-75px', [theme.breakpoints.down('sm')]: { flexDirection: 'row', marginLeft: 0, marginTop: 50 } },
    shareContainer2: { display: 'flex', flexDirection: 'column', position: 'absolute', top: 0, right: 25, [theme.breakpoints.only('md')]: { top: 360, right: 10 } },
    paragraphContainer: {
        // height: 500,
        [theme.breakpoints.only('md')]: { paddingRight: 30 },
        position: 'relative',
        // overflowY: 'scroll',
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    img: { width: '100%' },
    imgLogo: { display: 'flex', maxWidth: 275, zIndex: 1, marginTop: '-50px', marginLeft: 3 },
    tableContainer: { border: '1px solid black', width: '100%', borderCollapse: 'collapse' },
    tableRow: { border: '1px solid black', padding: '5px 10px 10px 10px' },
    tableRowName: { border: '1px solid black', padding: '5px 10px 10px 10px', color: '#21898A', width: 170, fontWeight: 'bold' },
    skillTitle: { color: '#21898A', textDecoration: 'underline', fontWeight: 'bold' },
    skillContainer: { display: 'flex', justifyContent: 'space-around' },
    leftLogo: { width: 90, height: 90 },
    logoHeaderContainer: {
        display: 'flex',
        marginLeft: '121px',
        marginTop: '10px',
        marginBottom: '10px',
        alignItems: 'flex-end',
        [theme.breakpoints.down('md')]: { maxWidth: 730, margin: '0 auto' },
        [theme.breakpoints.down('sm')]: { marginLeft: 0 },
    },
    closeIconContainer: { display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' },
    closeIcon: { color: '#A4A6A5' },
    backToTopContainer: { display: 'flex', justifyContent: 'flex-end', maxWidth: '905px' },
    backToTopText: {
        textDecoration: 'underline',
        color: '#1DA98E',
        fontStyle: 'italic',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: 18,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    flexSpaceBetween: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    copyRightText: {
        marginLeft: theme.spacing(20),
        fontSize: '18px',
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '0px',
            fontSize: '14px',
            maxWidth: '220px',
        },
    },
    dressingLink: {},
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, handleCloseIcon } = params;

    const defns = {
        icon: { fontSize: '30px', color: '#FC821F', opacity: 1 },
        navIconLeft: { marginLeft: '10px' },
        navIconRight: { marginLeft: '3px' },
        cardContainer: { container: true, spacing: 5 },
        cardSection: { item: true, lg: 4, md: 6, sm: 12, xs: 12 },
        cardIcon: { color: 'rgba(17, 30, 20, 0.4)' },
        pageContent: { container: true },
        paragraphContainer: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        shareContainer: { item: true, lg: 0, md: 0, sm: 12, xs: 12 },
        closeIcon: { onClick: handleCloseIcon },
        dressingLink: { target: '_blank', href: '/resource-center/3' },
        resourceCenterText: { target: '_blank', href: '/resource-center' },
        creatingResumeLink: { target: '_blank', href: '/resource-center/1' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ArticleTwo = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const theme = useTheme();
    // const matchesMd = useMediaQuery(theme.breakpoints.down('md'));
    const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));
    const history = useHistory();
    const myRef = useRef(null);

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const pageTitle = `Interviews: Let’s Nail It! | ${PAGE_TITLE_RESOURCE_CENTER}`;
    const pageTitleSeo = 'Successful Interview Techniques and Tips';

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(pageTitle);
    }, [pageTitle]);

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleNextButton = () => {
        history.push('/resource-center/3');
    };
    const handlePreviousButton = () => {
        history.push('/resource-center/1');
    };
    const handleCloseIcon = () => {
        history.push('/resource-center');
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, handleCloseIcon });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <AfitdPageHead
                title={pageTitleSeo}
                description="Are you feeling anxious about your upcoming job interview? A Foot in the Door is here to help! you will be prepared and ready to ace the job interview process."
                keywords="successful interview techniques, Interview Techniques, and Tips, interview techniques, successful interview tips, ace job interview"
                canonicalUrl={`https://${AFITD_DOMAIN}${PATH_RESOURCE_CENTER}/2`}
            />
            <div ref={myRef} />
            <p {...defns.topText}>6 min read</p>
            <div {...defns.closeIconContainer}>
                <CloseIcon {...defns.closeIcon} />
            </div>
            <h1 {...defns.heading}>Interviews: Let’s Nail It!</h1>
            <div {...defns.navigations}>
                <div {...defns.navigationButtonContainer} onClick={handlePreviousButton}>
                    <div {...defns.navigationIconContainer}>
                        <ArrowBackIosIcon style={{ ...defns.navIconLeft }} />
                    </div>
                    <span {...defns.navigationText}>Previous</span>
                </div>
                <div {...defns.navigationButtonContainer} onClick={handleNextButton}>
                    <span {...defns.navigationText}>Next</span>
                    <div {...defns.navigationIconContainer}>
                        <ArrowForwardIosIcon style={{ ...defns.navIconRight }} />
                    </div>
                </div>
            </div>

            <div {...defns.bannerImg}>
                <img {...defns.img} src={bannerImg} alt="" />
                <img {...defns.imgLogo} src={bannerLogo} alt="" />
            </div>

            <Grid {...defns.pageContent}>
                {matchesSm ? (
                    <>
                        <Grid {...defns.paragraphContainer}>
                            <div style={{ height: '100%' }} autoHide={false}>
                                <p {...defns.paragraph}>
                                    For new job seekers and old pros alike the interview process can be one of the more anxiety-inducing aspects of procuring new employment. You
                                    might start thinking, “what questions will be asked?” “What if I don’t know the answers?” “What do I wear?” “Am I even qualified for this
                                    position?” <br /> <br />
                                    Okay, first, let’s take a breath. Go ahead and inhale to four and exhale to four. We’ll wait... <br /> <br />
                                    There, that’s better! Trust us, we get how overwhelming interviews can be. Being in an unfamiliar environment and meeting new people might be
                                    outside the zone of comfort, but let’s not panic. With a little bit of prep work, you are going to crush this! Your pals at A Foot in the Door
                                    are here to guide you every step of the way. Let’s do this!
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={homeLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Do Your Homework</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    Research the company interviewing you. You’ll want to know some of their history, but more importantly, you need to ensure that you are well
                                    versed in their product or service, their target customer, and their values. You can use this knowledge, along with the qualifications listed in
                                    the position description and your own experience, to begin crafting answers to the standard interview questions that most companies ask (more on
                                    that below). <br /> <br /> Additionally, you’ll need to be intimately acquainted with your resume. Odds are you’ll be asked a couple of
                                    questions based specifically on your own experience. Be prepared with examples of your work, and if you can provide metrics (i.e., because of
                                    something you did, customer retention boosted by 20%, etc.), even better. <br /> <br /> If you need help putting your resume together, check out
                                    this blog post all about{' '}
                                    <a href="/resource-center/1" target="_blank">
                                        Creating a Modern Resume Like a Boss.
                                    </a>
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={questionLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Question Prep</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    We of course can’t guarantee what questions will be asked during your interview (we left our crystal ball in our other pants), but you’ll find
                                    some helpful tips to a few of the more commonly asked questions below. <br /> <br />
                                    When composing the answers to these questions, remember that your responses need to set you apart from the other candidates. The interviewer has
                                    probably had to listen to someone answer the same questions over and over, which has to get dull eventually. Stand out from the pack by making
                                    your answers interesting and engaging.
                                </p>
                                <br />
                                <h1 {...defns.questionTitle}>Question: “Tell Me About Yourself.”</h1>
                                <br />
                                <p {...defns.paragraph}>
                                    This will most likely be the first thing you’re asked. It’s probably the easiest question, because who knows more about you than you, but it
                                    tends to be one that many are not prepared to answer. Don’t overthink it, but also, now is not the time to be basic. This is the first pitch.
                                    Your first face-to-face impression. Sell it! You don’t just love animals and like to hit up a hiking trail on the weekends. You’re an advocate
                                    and friend to the voiceless, as well as an avid off-road explorer! Paint them a picture of your life with your magnificent words.
                                </p>
                                <br />
                                <h1 {...defns.questionTitle}>Question: “What Would You Say is Your Biggest Weakness?”</h1>
                                <br />
                                <p {...defns.paragraph}>
                                    This question is challenging and almost unfair. You’re already feeling vulnerable dishing about your life to this perfect stranger, and now they
                                    want to know what makes you weak? Kind of a sick joke, but okay, let’s play along. What they don’t know, is that you know, exactly how to answer
                                    this. You will admit your weakness, but then PLOT TWIST, you will also reveal that said weakness is actually a work in progress. There is no
                                    weakness that can’t be strengthened.
                                    <br />
                                    <br />
                                    <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>Example Answer:</span> As a developer, I’ve always been a “behind-the-scenes,” kind of
                                    person. I find it easier to work independently and based off of feedback from past teammates became aware that I’m not always the best
                                    collaborator. Ultimately, I know that teamwork is critical to producing a quality product, so I signed up for a group training on how to be a
                                    better team member. I’ve learned that communication, active listening, and mutual respect for all ideas is essential to being a team player, and
                                    plan on putting that knowledge into practice in all my future endeavors
                                </p>
                                <br />
                                <h1 {...defns.questionTitle}>Question: “What interests you about this position?”</h1>
                                <br />
                                <p {...defns.paragraph}>
                                    Use your skillset to your advantage. Be familiar with the qualifications they are looking for in their candidate and talk them through how your
                                    experience sets you up to be exactly who they are looking for. Also, make it personal. Is this position a steppingstone to your dream job? Have
                                    you been dying to work with this company because they are the best of the best in their industry, and you know that the experience you gain
                                    there will be invaluable to your overall career trajectory? Yes? Awesome, let them know!
                                </p>
                                <br />
                                <h1 {...defns.questionTitle}>Question: “Tell us about a professional conflict you experienced and how you handled that conflict.”</h1>
                                <br />
                                <p {...defns.paragraph}>
                                    Unless you enjoy awkward pauses, this is one answer you will want to prep ahead of time. When you’re in positivity mode (as one should be for an
                                    interview) you probably won’t be able to whip up a negative conflict on the fly, and you’re going to want to be able to hype your outstanding
                                    problem resolution capabilities. This is where knowing the position qualifications comes in handy. Think about a past problem you’ve solved,
                                    either on your own or with a team, that pertains to one or more of those qualifications and you will be golden.
                                </p>

                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={interviewLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Virtual Interviews</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    Here at A Foot in the Door, we are all about the virtual interview. When it comes to interview etiquette, you’ll find that many of the rules you
                                    would follow in-person you should also follow virtually. We jotted them down for you just in case you need a refresher.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Be Early: </span> Technology is amazing (holy wow, face-to -face interviews via a computer screen is a
                                    thing that’s possible now), but it can also be fickle. If possible, try to login to your virtual interview space 5-10 minutes early to ensure
                                    that your camera and microphone are working properly.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Set-Up: </span> Your Even though you’ll most likely be in the comfort of your own home, it’s probably not a
                                    great idea to be chillin’ on your bed, in your jammies, with that dope Post Malone concert poster in clear view during your interview. Position
                                    yourself in a well-lit, clean, and quiet space where you can sit-up nice and tall (a confidence move) so that your interviewer can see you
                                    clearly.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>The Look: </span>
                                    Your research of the company should let you know their dress standards. Take that into account when picking out your interview outfit, as well
                                    as your own comfort level. There’s no need to rock six-inch stilettos, unless of course that makes you feel confident then go for it, but in our
                                    experience it’s more difficult to concentrate on answering questions when your toes have lost all circulation. You can also check out this blog
                                    post on <a {...defns.dressingLink}>Dressing for Success</a> for more tips in the wardrobe department.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}> Eye Contact: </span>
                                    It’s harder to maintain direct eye contact via video conference as this can only be achieved if looking straight into the webcam. It’s ok if you
                                    look at the screen while you are listening, but while answering, try your best to look into the webcam to deliver your answer. Also, avoid
                                    staring at yourself in that little box in the corner, or on the other side of the screen. Yes, you’re gorgeous, but continuously checking
                                    yourself out might make you appear distracted, so keep those peepers looking straight ahead and focused on scoring a great opportunity. <br />
                                    <br />
                                    Follow these tips and you’ll be well on your way to interview stardom. Companies will be lining up to interview you once word spreads of your
                                    exceptional storytelling capabilities, not to mention your phenomenal skillsets! We don’t need that crystal ball to see that there will be many
                                    doors opening for you, friend! <br />
                                    <br /> If you need more assistance as you prepare to take on the working world, be sure to check out our other job-prep blog offerings in the{' '}
                                    <a {...defns.resourceCenterText}>Resource Center.</a>
                                </p>
                            </div>
                        </Grid>
                        {/* <Grid {...defns.shareContainer}>
                            <Tooltip title="Share the article on LinkedIn" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg1} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Share the article on Twitter" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg2} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Share the article on Facebook" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg3} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Copy the article link" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg4} alt="" />
                                </div>
                            </Tooltip>
                        </Grid> */}
                    </>
                ) : (
                    <>
                        <Grid {...defns.paragraphContainer}>
                            <div style={{ height: '100%' }} autoHide={false}>
                                <p {...defns.paragraph}>
                                    For new job seekers and old pros alike the interview process can be one of the more anxiety-inducing aspects of procuring new employment. You
                                    might start thinking, “what questions will be asked?” “What if I don’t know the answers?” “What do I wear?” “Am I even qualified for this
                                    position?” <br /> <br />
                                    Okay, first, let’s take a breath. Go ahead and inhale to four and exhale to four. We’ll wait... <br /> <br />
                                    There, that’s better! Trust us, we get how overwhelming interviews can be. Being in an unfamiliar environment and meeting new people might be
                                    outside the zone of comfort, but let’s not panic. With a little bit of prep work, you are going to crush this! Your pals at A Foot in the Door
                                    are here to guide you every step of the way. Let’s do this!
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={homeLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Do Your Homework</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    Research the company interviewing you. You’ll want to know some of their history, but more importantly, you need to ensure that you are well
                                    versed in their product or service, their target customer, and their values. You can use this knowledge, along with the qualifications listed in
                                    the position description and your own experience, to begin crafting answers to the standard interview questions that most companies ask (more on
                                    that below). <br /> <br /> Additionally, you’ll need to be intimately acquainted with your resume. Odds are you’ll be asked a couple of
                                    questions based specifically on your own experience. Be prepared with examples of your work, and if you can provide metrics (i.e., because of
                                    something you did, customer retention boosted by 20%, etc.), even better. <br /> <br /> If you need help putting your resume together, check out
                                    this blog post all about{' '}
                                    <a href="/resource-center/1" target="_blank">
                                        Creating a Modern Resume Like a Boss.
                                    </a>
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={questionLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Question Prep</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    We of course can’t guarantee what questions will be asked during your interview (we left our crystal ball in our other pants), but you’ll find
                                    some helpful tips to a few of the more commonly asked questions below. <br /> <br />
                                    When composing the answers to these questions, remember that your responses need to set you apart from the other candidates. The interviewer has
                                    probably had to listen to someone answer the same questions over and over, which has to get dull eventually. Stand out from the pack by making
                                    your answers interesting and engaging.
                                </p>
                                <br />
                                <h1 {...defns.questionTitle}>Question: “Tell Me About Yourself.”</h1>
                                <br />
                                <p {...defns.paragraph}>
                                    This will most likely be the first thing you’re asked. It’s probably the easiest question, because who knows more about you than you, but it
                                    tends to be one that many are not prepared to answer. Don’t overthink it, but also, now is not the time to be basic. This is the first pitch.
                                    Your first face-to-face impression. Sell it! You don’t just love animals and like to hit up a hiking trail on the weekends. You’re an advocate
                                    and friend to the voiceless, as well as an avid off-road explorer! Paint them a picture of your life with your magnificent words.
                                </p>
                                <br />
                                <h1 {...defns.questionTitle}>Question: “What Would You Say is Your Biggest Weakness?”</h1>
                                <br />
                                <p {...defns.paragraph}>
                                    This question is challenging and almost unfair. You’re already feeling vulnerable dishing about your life to this perfect stranger, and now they
                                    want to know what makes you weak? Kind of a sick joke, but okay, let’s play along. What they don’t know, is that you know, exactly how to answer
                                    this. You will admit your weakness, but then PLOT TWIST, you will also reveal that said weakness is actually a work in progress. There is no
                                    weakness that can’t be strengthened.
                                    <br />
                                    <br />
                                    <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>Example Answer:</span> As a developer, I’ve always been a “behind-the-scenes,” kind of
                                    person. I find it easier to work independently and based off of feedback from past teammates became aware that I’m not always the best
                                    collaborator. Ultimately, I know that teamwork is critical to producing a quality product, so I signed up for a group training on how to be a
                                    better team member. I’ve learned that communication, active listening, and mutual respect for all ideas is essential to being a team player, and
                                    plan on putting that knowledge into practice in all my future endeavors
                                </p>
                                <br />
                                <h1 {...defns.questionTitle}>Question: “What interests you about this position?”</h1>
                                <br />
                                <p {...defns.paragraph}>
                                    Use your skillset to your advantage. Be familiar with the qualifications they are looking for in their candidate and talk them through how your
                                    experience sets you up to be exactly who they are looking for. Also, make it personal. Is this position a steppingstone to your dream job? Have
                                    you been dying to work with this company because they are the best of the best in their industry, and you know that the experience you gain
                                    there will be invaluable to your overall career trajectory? Yes? Awesome, let them know!
                                </p>
                                <br />
                                <h1 {...defns.questionTitle}>Question: “Tell us about a professional conflict you experienced and how you handled that conflict.”</h1>
                                <br />
                                <p {...defns.paragraph}>
                                    Unless you enjoy awkward pauses, this is one answer you will want to prep ahead of time. When you’re in positivity mode (as one should be for an
                                    interview) you probably won’t be able to whip up a negative conflict on the fly, and you’re going to want to be able to hype your outstanding
                                    problem resolution capabilities. This is where knowing the position qualifications comes in handy. Think about a past problem you’ve solved,
                                    either on your own or with a team, that pertains to one or more of those qualifications and you will be golden.
                                </p>

                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={interviewLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Virtual Interviews</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    Here at A Foot in the Door, we are all about the virtual interview. When it comes to interview etiquette, you’ll find that many of the rules you
                                    would follow in-person you should also follow virtually. We jotted them down for you just in case you need a refresher.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Be Early: </span> Technology is amazing (holy wow, face-to -face interviews via a computer screen is a
                                    thing that’s possible now), but it can also be fickle. If possible, try to login to your virtual interview space 5-10 minutes early to ensure
                                    that your camera and microphone are working properly.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Set-Up: </span> Your Even though you’ll most likely be in the comfort of your own home, it’s probably not a
                                    great idea to be chillin’ on your bed, in your jammies, with that dope Post Malone concert poster in clear view during your interview. Position
                                    yourself in a well-lit, clean, and quiet space where you can sit-up nice and tall (a confidence move) so that your interviewer can see you
                                    clearly.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>The Look: </span>
                                    Your research of the company should let you know their dress standards. Take that into account when picking out your interview outfit, as well
                                    as your own comfort level. There’s no need to rock six-inch stilettos, unless of course that makes you feel confident then go for it, but in our
                                    experience it’s more difficult to concentrate on answering questions when your toes have lost all circulation. You can also check out this blog
                                    post on <a {...defns.dressingLink}>Dressing for Success</a> for more tips in the wardrobe department.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}> Eye Contact: </span>
                                    It’s harder to maintain direct eye contact via video conference as this can only be achieved if looking straight into the webcam. It’s ok if you
                                    look at the screen while you are listening, but while answering, try your best to look into the webcam to deliver your answer. Also, avoid
                                    staring at yourself in that little box in the corner, or on the other side of the screen. Yes, you’re gorgeous, but continuously checking
                                    yourself out might make you appear distracted, so keep those peepers looking straight ahead and focused on scoring a great opportunity. <br />
                                    <br />
                                    Follow these tips and you’ll be well on your way to interview stardom. Companies will be lining up to interview you once word spreads of your
                                    exceptional storytelling capabilities, not to mention your phenomenal skillsets! We don’t need that crystal ball to see that there will be many
                                    doors opening for you, friend! <br />
                                    <br /> If you need more assistance as you prepare to take on the working world, be sure to check out our other job-prep blog offerings in the{' '}
                                    <a {...defns.resourceCenterText}>Resource Center.</a>
                                </p>

                                {/* <div {...defns.shareContainer2}>
                                <Tooltip title="Share the article on LinkedIn" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg1} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Share the article on Twitter" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg2} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Share the article on Facebook" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg3} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Copy the article link" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg4} alt="" />
                                    </div>
                                </Tooltip>
                            </div> */}
                            </div>
                        </Grid>
                    </>
                )}
            </Grid>

            <hr {...defns.hr} />
            <div {...defns.backToTopContainer}>
                <div {...defns.flexSpaceBetween}>
                    <div {...defns.copyRightText}>{getCopyrightText()}</div>
                    <p
                        {...defns.backToTopText}
                        onClick={() => {
                            setTimeout(() => {
                                myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 100);
                        }}
                    >
                        Back to the top
                    </p>
                </div>
            </div>

            {/* <h2 {...defns.heading}>Related Content</h2>
            <Grid {...defns.cardContainer}>
                <Grid {...defns.cardSection}>
                    <div {...defns.card}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={cardImg1} alt="" />
                        </div>
                        <div {...defns.cardContent}>
                            <p {...defns.dateTime}>2 min read</p>
                            <h3 {...defns.cardHeading}>Remote Workstations for the Discerning Artists</h3>
                            <p {...defns.cardParagraph}>
                                Netflix is poised to become the world’s most prolific producer of visual effects and original animated content. To meet that demand, we need to
                                attract the world’s best artistic talent.{' '}
                            </p>
                        </div>
                    </div>
                </Grid>
                <Grid {...defns.cardSection}>
                    <div {...defns.card}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={cardImg2} alt="" />
                        </div>
                        <div {...defns.cardContent}>
                            <p {...defns.dateTime}>2 min read</p>
                            <h3 {...defns.cardHeading}>Working Remotely: A Complete Guide to Turn You Into a Pro</h3>
                            <p {...defns.cardParagraph}>
                                Working remotely is more difficult in practice than in theory. Turn to this guide with actionable advice from veteran remote workers on how to
                                handle challenges that are
                            </p>
                        </div>
                    </div>
                </Grid>
                {matchesMd ? (
                    <></>
                ) : (
                    <Grid {...defns.cardSection}>
                        <div {...defns.card}>
                            <div {...defns.imageContainer}>
                                <img {...defns.img} src={cardImg3} alt="" />
                            </div>
                            <div {...defns.cardContent}>
                                <p {...defns.dateTime}>2 min read</p>
                                <h3 {...defns.cardHeading}>Brent Potts Joins Airbnb as Vice President of Community Support</h3>
                                <p {...defns.cardParagraph}>
                                    Today we are excited to announce that Brent Potts has joined Airbnb as Vice President of Community Support. Lorem ipsum dolor sit amet.
                                </p>
                            </div>
                        </div>
                    </Grid>
                )}
            </Grid> */}
        </div>
    );
};

export default ArticleTwo;
